import React from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

import IntroCard from './IntroCard';

import Card from './Card';
import { StyledCardStack } from './CardStack';

const CardStackAnimation = ({ introCard, className }) => {
  const CARD_OFFSET = typeof window !== 'undefined' && window.innerWidth < 768 ? 20 : 26;

  const cards = [1, 2, 3];

  return (
    <StyledCardStack className={className}>
      <div className="card-stack__wrapper">
        <motion.div
          animate={{
            x: 0,
            y: 0,
            z: 0,
            zIndex: (cards.length || 0) + 1,
            opacity: 1,
            pointerEvents: 'none'
          }}
          transition={{
            ease: 'linear',
            duration: 1
          }}
          className="card-stack__card"
        >
          <IntroCard
            headline={introCard.headline}
            subline={introCard.headlineSmall}
            copy={introCard.copy}
          />
        </motion.div>

        {cards.map(index => {
          const offset = index * CARD_OFFSET;
          const x = offset;
          const y = offset * -1;
          const z = offset * -1;

          return (
            <motion.div
              key={index}
              animate={{
                x,
                y,
                z,
                zIndex: (cards?.length || 0) - index,
                opacity: 1,
                pointerEvents: 'none'
              }}
              transition={{
                ease: 'linear',
                duration: 0.4,
                delay: index * 0.2,
                opacity: {
                  duration: 0.2
                }
              }}
              initial={{
                x: x + 40,
                y: y - 30,
                z,
                opacity: 0
              }}
              exit={{
                opacity: 0,
                transition: { duration: 0, delay: 0 }
              }}
              className="card-stack__card"
            >
              <Card />
            </motion.div>
          );
        })}
      </div>
    </StyledCardStack>
  );
};

CardStackAnimation.propTypes = {
  introCard: PropTypes.shape(),
  className: PropTypes.string
};

export default CardStackAnimation;
